import * as React from 'react';
import classnames from 'classnames';
import ErrorBlock from './ErrorBlock';
import { FormComponent } from './Form';
import { formatAsElementId } from './Utils';
import { cloneExcept } from '../../utils';
import { Binding, Result } from 'core/infrastructure';

interface Props<T> extends React.HTMLProps<Label<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string;
	format?: (value: any) => string;
	boundValue?: any;
	formId?: string;
}

interface State {
	value?: string;
	errorMsg?: string;
}

export class Label<T> extends React.Component<Props<T>, State> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);

		if (typeof props.boundValue === 'undefined') {
			throw Error('BoundValue no está definida para el Label');
		}

		this.state = {
			value: props.format
				? props.format(props.boundValue)
				: (props.boundValue === null ? '' : props.boundValue.toString()),
			errorMsg: ''
		};
	}

	getPath(): string {
		return Binding.propertyPathToString(this.props.linkTo);
	}

	showErrors(errors: string[]): void {
		this.setState({ errorMsg: errors.join(' ') });
	}

	getValue(): Result<any> {
		this.setState({ errorMsg: '' });
		return Result.ok(this.props.boundValue);
	}

	render() {

		const classes = classnames({ 'form-group': true, 'has-error': !!this.state.errorMsg });

		const props = cloneExcept(this.props, ['label', 'linkTo', 'format', 'boundValue', 'formId']);

		const label = this.props.label ? <label className='col-sm-4 control-label'>{this.props.label || ''}</label> : null;

		const staticClasses = classnames({ 'form-control-static': true, 'col-sm-8': !!label, 'col-sm-12': !label });

		return <div className={classes}>
			{label}

			<label id={formatAsElementId(this.getPath(), this.props.formId || '')} className={staticClasses} {...props}>&nbsp;{this.state.value}</label>
			<ErrorBlock msg={this.state.errorMsg} />
		</div>;
	}
}
export type LabelCtor<T> = new (props: Props<T>) => React.Component<Props<T>, State>;
